export const zero = () => 0
